import React from 'react';
import PropTypes from 'prop-types';
import {
  getBestPossibleDisplay,
  getGamesBehindDisplay,
  getLocksRemainingDisplay,
  getMarginDisplay,
  getWinPctDisplay,
} from '../../utils/standingsUtils';
import styles from './MobileStandingsCard.module.css';

const MobileStandingsCard = ({
  player,
  isCurrentUser,
  isExpanded,
  onToggleExpand,
  onUsernameClick,
}) => {
  const record = `${player.wins || 0}-${player.losses || 0}`;
  const rankDisplay = player.rank ?? '-';

  const handleUsernameKeyDown = (event) => {
    if (event.key === 'Enter' || event.key === ' ') {
      event.preventDefault();
      event.stopPropagation();
      onUsernameClick(player.username);
    }
  };

  return (
    <article
      className={`${styles.card} ${isCurrentUser ? styles.currentUser : ''} ${isExpanded ? styles.expanded : ''}`}
    >
      <div
        className={styles.summary}
        role="button"
        tabIndex={0}
        onClick={onToggleExpand}
        onKeyDown={(event) => {
          if (event.key === 'Enter' || event.key === ' ') {
            event.preventDefault();
            onToggleExpand();
          }
        }}
      >
        <div className={styles.rankBadge}>{rankDisplay}</div>
        <div className={styles.body}>
          <div className={styles.primary}>
            <span
              role="button"
              tabIndex={0}
              className={styles.usernameLink}
              onClick={(event) => {
                event.stopPropagation();
                onUsernameClick(player.username);
              }}
              onKeyDown={handleUsernameKeyDown}
            >
              {player.username}
            </span>
            <div className={styles.record}>{record}</div>
          </div>
          <div className={styles.quickStats}>
            <span>GB {getGamesBehindDisplay(player.gamesBehind)}</span>
            <span>{getWinPctDisplay(player.wins, player.losses)}</span>
            <span>{getMarginDisplay(player.accumulated_margin)} tot</span>
          </div>
        </div>
      </div>

      {isExpanded && (
        <div className={styles.details}>
          <div className={styles.detailGrid}>
            <div><span>Avg margin</span><strong>{getMarginDisplay(player.average_margin)}</strong></div>
            <div><span>Locks left</span><strong>{getLocksRemainingDisplay(player.locks_remaining)}</strong></div>
            <div><span>Best possible</span><strong>{getBestPossibleDisplay(player.best_possible, player.losses, player.effective_losses)}</strong></div>
            <div><span>Bye used</span><strong>{player.bye_used === 1 ? 'Yes' : 'No'}</strong></div>
          </div>
          <div className={styles.pickHabits}>
            <span>Fav {player.fav_pics || 0}</span>
            <span>Dog {player.dog_picks || 0}</span>
            <span>PK {player.pk_picks || 0}</span>
            <span>Over {player.over_picks || 0}</span>
            <span>Under {player.under_picks || 0}</span>
          </div>
        </div>
      )}
    </article>
  );
};

MobileStandingsCard.propTypes = {
  player: PropTypes.shape({
    username: PropTypes.string.isRequired,
    rank: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    wins: PropTypes.number,
    losses: PropTypes.number,
    gamesBehind: PropTypes.number,
    accumulated_margin: PropTypes.number,
    average_margin: PropTypes.number,
    locks_remaining: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    best_possible: PropTypes.number,
    effective_losses: PropTypes.number,
    bye_used: PropTypes.number,
    fav_pics: PropTypes.number,
    dog_picks: PropTypes.number,
    pk_picks: PropTypes.number,
    over_picks: PropTypes.number,
    under_picks: PropTypes.number,
  }).isRequired,
  isCurrentUser: PropTypes.bool,
  isExpanded: PropTypes.bool,
  onToggleExpand: PropTypes.func.isRequired,
  onUsernameClick: PropTypes.func.isRequired,
};

export default MobileStandingsCard;
